/**
 * Base URL for API calls.
 * In dev only: when VITE_API_URL is an absolute URL (different origin), we use "/v1"
 * so the Vite dev proxy handles the request and avoids CORS. In staging/prod there is no proxy;
 * we use VITE_API_URL and the backend must send CORS headers.
 */
const staticUrl = import.meta.env.VITE_API_URL ?? '';
const useProxy = import.meta.env.DEV && /^https?:\/\//.test(staticUrl);

export const apiBaseUrl = useProxy ? '/v1' : staticUrl;
